














import { Vue, Component } from 'vue-property-decorator';
import ReportesSMS from '@/pantallas/TorreControl/ReportesSMS/ReportesSMS.vue';

@Component({
  components: { ReportesSMSComponent: ReportesSMS },
})
export default class ConfiguracionComandosSMSPantalla extends Vue {}
